import React, { Component } from 'react';
import { connect } from 'react-redux';
import AuthPageForm from './authpageform.component';
import { requestLogin } from '../../../SHARED/actions/user.actions';
import {Link} from "react-router-dom";
import {REGISTER_ROUTE, FORGOT_PASSWORD} from "../../config/routes";
import { Button } from 'reactstrap';
//import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { requestLoginFacebook, requestLoginGoogle } from '../../../SHARED/actions/user.actions';
import { storeFacebookOrGoogleResponse } from '../../../SHARED/actions/profile.actions';
import GoogleLogin from "react-google-login";
import { email } from 'redux-form-validators';
import { FacebookProvider, Login } from 'react-facebook';


class AuthPage extends Component {
    constructor(props) {
        super(props);
        this.doLogin = this.doLogin.bind(this);
    }

    doLogin(data) {
        this.props.requestLogin(data);
    }

    showErrors() {
        return typeof(this.props.loginErrors) === "object" ? '' : this.props.loginErrors;
    }

    // responseFacebook = (response) => {
    //     //this.signUp(response, 'google');
    //     const payload = {
    //         first_name: response.name.split(' ').slice(0, -1).join(' '),
    //         last_name: response.name.split(' ').slice(-1).join(' '),
    //         email: response.email
    //     }
    //     this.props.storeFacebookOrGoogleResponse(payload);
    //     this.props.requestLoginFacebook(response);
    // };

    responseGoogle = (response) => {
        //this.signUp(response, 'google');
        this.props.requestLoginGoogle(response);
    };

    handleResponse = (response) => {
        const payload = {
            first_name: response.profile.first_name,
            last_name: response.profile.last_name,
            email: response.profile.email
        }
        this.props.storeFacebookOrGoogleResponse(payload);
        this.props.requestLoginFacebook(response);
    }

    handleError = (error) => {
        console.log(error);
    }

    render(){
        return (
            <div className="auth-page">

                <div className="errorsHolder text-center white-text">
                    { this.showErrors() }
                </div>
                <div className="col-lg-12 text-center">
                    <AuthPageForm onSubmit={this.doLogin} />
                </div>
                <div className="col-lg-12 text-center clearfix">
                    <Link to={FORGOT_PASSWORD}>
                        <Button size="lg" className="btn-cinemap-blue forgot-password btn-landing">Ai uitat parola?</Button>
                    </Link>
                </div>
                <div className="col-lg-12 text-center">
                    <Link to={REGISTER_ROUTE}>
                        <Button size="lg" className="btn-cinemap-blue register-site btn-landing">Înregistrează-te</Button>
                    </Link>
                </div>

                <div className="col-lg-12 text-center">
                    {/* <FacebookLogin
                        appId={ process.env.REACT_APP_ENVIRONMENT === 'STAGE' ?  process.env.REACT_APP_STAGE_FB_APP_ID : process.env.REACT_APP_PROD_FB_APP_ID}
                        autoLoad={false}
                        callback={(response) => this.responseFacebook(response)}
                        fields="name,email,picture"
                        render={renderProps => (
                            <button onClick={renderProps.onClick} className="social-login login-facebook"></button>
                        )}
                    /> */}
                    <FacebookProvider appId={process.env.REACT_APP_ENVIRONMENT === 'STAGE' ?  process.env.REACT_APP_STAGE_FB_APP_ID : process.env.REACT_APP_PROD_FB_APP_ID}>
                        <Login
                            scope="email"
                            onCompleted={this.handleResponse}
                            onError={this.handleError}
                        >
                            {({ loading, handleClick, error, data }) => (
                                <button onClick={handleClick} className="social-login login-facebook"></button>
                            )}
                        </Login>       
                    </FacebookProvider>
                </div>

                <div className="col-lg-12 text-center">
                    <GoogleLogin
                        clientId={ process.env.REACT_APP_ENVIRONMENT === 'STAGE' ?  process.env.REACT_APP_STAGE_GOOGLE_APP_ID : process.env.REACT_APP_PROD_GOOGLE_APP_ID }
                        buttonText="Login"
                        onSuccess={(response) => this.responseGoogle(response)}
                        onFailure={(response) => this.responseGoogle(response)}
                        autoLoad={false}
                        render={renderProps => (
                            <button onClick={renderProps.onClick} className="social-login login-google"></button>
                        )}
                    />
                </div>

                <div className="col-lg-12 text-center advantages white-text">
                    Intră în clubul Cinemap și descoperă toate <br/> avantajele de care se bucură un user autentificat!
                </div>

                <div className="col-lg-12 text-center">
                    <span className="download-icon"></span>
                    <span className="download-label">Descarcă aplicația!</span>
                </div>

                <div className="col-lg-12 apps-section">
                    <div className="row">
                        <div className="col-sm-6 hr-padding-5">
                            <a href={ process.env.REACT_APP_PLAY_STORE_URL } target="_blank">
                                <span className="apps google-play"></span>
                            </a>

                        </div>
                        <div className="col-sm-6 hr-padding-5">
                            <a href={ process.env.REACT_APP_APPLE_STORE_URL } target="_blank">
                                <span className="apps apple-store"></span>
                            </a>
                        </div>
                    </div>
                </div>



            </div>
        );
    }
}
const mapStateToProps = state => ({
    loginErrors: state.user.errors
});
export default connect(mapStateToProps, { requestLogin, requestLoginFacebook, requestLoginGoogle, storeFacebookOrGoogleResponse })(AuthPage);



// WEBPACK FOOTER //
// ./src/SHARED/components/auth/authpage.component.js